import { render, staticRenderFns } from "./AdminConsoleSideNav.vue?vue&type=template&id=3d67d667&scoped=true"
import script from "./AdminConsoleSideNav.vue?vue&type=script&lang=js"
export * from "./AdminConsoleSideNav.vue?vue&type=script&lang=js"
import style0 from "./AdminConsoleSideNav.scss?vue&type=style&index=0&id=3d67d667&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d67d667",
  null
  
)

export default component.exports